import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW1309Component } from './kymw1309.component';
import { KYMW1309RoutingModule } from './kymw1309.routing.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetPromotionGoodsInfoService } from './api-service/get-promotion-goods-info.service';

/**
 * バンドルミックスマッチ検索画面 モジュール設定クラス
 *
 * @export KYMW1309Module
 * @class KYMW1309Module
 */
@NgModule({
  imports: [
    CommonModule,
    KYMW1309RoutingModule,
    PlessSharedModule,
    AppCommonsModule,
    WjNavModule,
    WjGridModule,
    FormsModule,
  ],
  declarations: [
    KYMW1309Component,
  ],
  providers: [
    GetPromotionGoodsInfoService,
  ],
})

export class KYMW1309Module { }
